<div *ngIf="uploaders && uploaders?.length > 0" class="mb-3">
  <nx-table-header
    class="text-[1rem]"
    [label]="'coreModule.uploaderStateViewComponent.headline' | translate">
  </nx-table-header>
  <div class="details-content">
    <div
      *ngFor="let uploader of uploaders"
      class="row flex flex-row basis-full api-row items-center">
      <div class="label basis-2/3 font-medium">{{uploader?.name}} <span class="text-[#848488] text-sm font-light leading-3">({{uploader?.id}})</span></div>
      <div class="flex basis-1/3 justify-end items-center">
        <p-tag
          [value]="calculateHealthStatus(uploader) | translate"
          [severity]="calculateSeverity(calculateHealthStatus(uploader))">
        </p-tag>
        <nx-default-button
          [style]="'light'"
          [clickable]="false"
          class="ml-2"
          [tooltip]="getTooltip(uploader)"
          (click)="$event.stopPropagation();"
          [icon]="'icon-info'">
        </nx-default-button>
      </div>
    </div>
  </div>
</div>